import { DOCUMENT } from 'entities/user/module'

import { TYPE_AGE } from 'shared/constants'

export const passportOptions = {
  [TYPE_AGE.ADULTS]: {
    passport: {
      name: 'passport',
      value: DOCUMENT.PASSPORT,
    },
    // idPassport: {
    //   name: 'id_passport',
    //   value: DOCUMENT.ID,
    // },
    idPassport: [
      {
        name: 'id_passport',
        value: DOCUMENT.ID,
      },
      {
        name: 'birth_certificate',
        value: DOCUMENT.BIRTH_CERTIFICATE,
      },
    ],
  },
  [TYPE_AGE.CHILDREN]: {
    passport: {
      name: 'passport',
      value: DOCUMENT.PASSPORT,
    },
    idPassport: {
      name: 'birth_certificate',
      value: DOCUMENT.BIRTH_CERTIFICATE,
    },
  },
  [TYPE_AGE.INFANTS_WITHOUT_SEAT]: {
    passport: {
      name: 'passport',
      value: DOCUMENT.PASSPORT,
    },
    idPassport: {
      name: 'birth_certificate',
      value: DOCUMENT.BIRTH_CERTIFICATE,
    },
  },
  // [TYPE_AGE.INFANTS_WITH_SEAT]: {
  //   passport: {
  //     name: 'passport',
  //     value: DOCUMENT.PASSPORT,
  //   },
  //   idPassport: {
  //     name: 'birth_certificate',
  //     value: DOCUMENT.BIRTH_CERTIFICATE,
  //   },
  // },
}

export const listPassports = [
  {
    name: 'passport',
    value: DOCUMENT.PASSPORT,
  },
  {
    name: 'id_passport',
    value: DOCUMENT.ID,
  },
  {
    name: 'birth_certificate',
    value: DOCUMENT.BIRTH_CERTIFICATE,
  },
]
